export default __webpack_public_path__ + "static/media/usa.c29455bd.svg";